import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../Buttons/MainButton";
import Input from "../../Inputs/Input";
import Selected from "../../Inputs/Selected";
import Title from "../../Title/Title";

interface ActivateInspectionsProps {}

const ActivateInspections: React.FC<ActivateInspectionsProps> = () => {
  return (
    <>
      <Row>
        <Col lg={6} md={5}>
          <Title title="مقرر القانون الجزائي" />
        </Col>
      </Row>
      <Row justify={"around"}>
        <Col lg={5} md={5} sm={11}>
          <Selected title="اسم المقرر">
            <option>AR</option>
            <option>EN</option>
            <option>FR</option>
          </Selected>
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Selected title="اسم القاعة">
            <option>الاولى</option>
            <option>الثانية</option>
            <option>الثالثة</option>
          </Selected>
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder=" عدد الطلاب المفروزين  " />
        </Col>

        <Col lg={5} md={5} sm={11}>
          <Input placeholder="عدد الطلاب الحاضرين " />
        </Col>

        <Col lg={5} md={5} sm={11}>
          <Input placeholder=" عدد الغياب " />
        </Col>
        <Col lg={5} md={5} sm={11}></Col>

        <Col
          lg={10}
          md={5}
          sm={11}
          className="flex lg:justify-end max-lg:mx-auto  !mt-4 "
        >
          <MainButton titlebtn="تفعيل التفقدات" className="w-[400px] mx-2 " />
          <MainButton
            titlebtn="الغاء التفقدات"
            className="w-[200px] !bg-gray-200  "
          />
        </Col>
      </Row>
    </>
  );
};

export default ActivateInspections;
